import React from 'react';
import IndicadorCard, { IndicadorCardProps } from './IndicadorCard';

const MetricsGrid: React.FC<{ itens: IndicadorCardProps[] }> = ({ itens }) => (
  <div className='mc-metrics'>
    {itens.map(item => <IndicadorCard key={item.id} {...item} />)}
  </div>
);

export default MetricsGrid;
